import FluxUtils from 'flux/utils';
import Immutable from 'immutable';

import type { ActionType } from 'sharedreact/actions/generic/actions';
import NavigationConstants from 'sharedreact/constants/NavigationConstants';
import NavigationView from 'sharedreact/data/NavigationView';
import AppDispatcher from 'sharedreact/dispatcher/AppDispatcher';

function _createNavigationView (action: ActionType): NavigationView {
  return new NavigationView({name: action.view, paramName: action.paramName, setValue: action.setValue, extraData: action.extraData});
}

const Content: {
  slideouts: Immutable.List<NavigationView>,
  dialogs: Immutable.Map<string, NavigationView>
} = {
  slideouts: Immutable.List(),
  dialogs: Immutable.Map()
};

class State extends Immutable.Record(Content) {
}

class NavigationStore extends FluxUtils.ReduceStore<State, ActionType> {
  constructor () {
    super(AppDispatcher);
  }

  override getInitialState (): State {
    return new State();
  }

  getSlideOutViews (): Immutable.List<NavigationView> {
    return this.getState().slideouts;
  }

  getSlideOutView (view: string): NavigationView | undefined {
    return this.getState().slideouts.find((slideout) => slideout.name === view);
  }

  isSlideOutVisible (view: string): boolean {
    return this.getSlideOutView(view) != null;
  }

  getDialogView (view: string): NavigationView | undefined {
    return this.getState().dialogs.get(view);
  }

  isDialogVisible (view: string): boolean {
    return this.getDialogView(view) != null;
  }

  override reduce (state: State, action: ActionType): State {
    switch (action.actionType) {
      case NavigationConstants.OPEN_SLIDEOUT: {
        const firstview: string | undefined = (state.slideouts.size === 0)
          ? undefined
          : state.slideouts.first()!.name;
        if (firstview != null || firstview !== action.view) {
          return state.set('slideouts', state.slideouts.push(_createNavigationView(action)));
        }
        return state;
      }
      case NavigationConstants.CHANGE_SLIDEOUT: {
        return state.set('slideouts', state.slideouts.pop().push(_createNavigationView(action)));
      }
      case NavigationConstants.CLOSE_SLIDEOUT: {
        return state.set('slideouts', state.slideouts.pop());
      }
      case NavigationConstants.CLOSE_ALL_SLIDEOUTS: {
        return state.set('slideouts', state.slideouts.clear());
      }
      case NavigationConstants.SHOW_DIALOG: {
        return state.set('dialogs', state.dialogs.set(action.view, _createNavigationView(action)));
      }
      case NavigationConstants.HIDE_DIALOG: {
        return state.set('dialogs', state.dialogs.remove(action.view));
      }
    }

    return state;
  }
}

export default new NavigationStore();
